import React from "react";
import { VoiceCloneCreatorOptions } from "../base/VoiceCloneSynthesis";
import { FILM_CONFIG } from "./filmConfig";

function FilmVoice(props) {
  return (
    <VoiceCloneCreatorOptions
      {...props}
      workshopConfig={FILM_CONFIG.voice}
    />
  );
}

export { FilmVoice };
